export const uk = {
    'cannot-be-empty': 'Необходимо заполнить поле',
    'default-error': 'Неизвестная ошибка: {errorCode}',
    'size-cannot-be-more-than-max': 'Можно добавить всего 5 дополнительных параметров',
    'this-tracking-system-domain-not-supported': 'Данный домен трекинговой системы не поддерживается',
    'this-tracking-system-domain-only-supports-https':
        'Данный домен трекинговой системы поддерживает только протокол https',
    'tracker-url-does-not-match-selected-tracker-system':
        'Домен трекинговой ссылки не соотвествует выбранной трекинговой системе',
    'tracking-url-doesnt-contain-macros':
        'Трекинговая ссылка должна содержать макросы для отслеживания устройств (logid, google_aid, ios_ifa)'
};
